export const PJM_BANNER_CUSTOM_TITLE_CATEGORIES_KEYS = {
    10: 'programming_tech_title',
    2: 'online_marketing_title',
    3: 'graphics_design_title',
    20: 'video_animation_title',
};
